import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getProduct } from '../../product-catalog/productPresentation';
import useExclusiveVideoPlayback from '../shared/useExclusiveVideoPlayback';
import { interviews, getStoryFilters } from './interviews';
import SuccessStoryCard from './SuccessStoryCard';
import '../shared/PortalContentPage.css';
import './SuccessStoriesPage.css';

export default function SuccessStoriesPage() {
  const { t } = useTranslation('app');
  const [filter, setFilter] = useState('all');
  const playback = useExclusiveVideoPlayback();
  const visibleInterviews = interviews.filter(item => filter === 'all' || item.productId === filter);
  return (
    <div className="portal-content-page success-stories-page">
      <div className="portal-content-page-inner">
        <header className="success-stories-header">
          <span className="portal-content-page-eyebrow">Hi-Portal</span>
          <h1>{t('navigation.successStories')}</h1><p>{t('successStories.description')}</p>
        </header>
        <div className="success-stories-filters" role="group" aria-label={t('successStories.filterLabel')}>
          {getStoryFilters(interviews).map(({ id, count }) => (
            <button key={id} type="button" aria-pressed={filter === id}
              onClick={() => { playback.pauseOthers(); setFilter(id); }}>
              {id === 'all' ? t('successStories.all') : getProduct(id).name}<span>{count}</span>
            </button>
          ))}
        </div>
        <div className="success-stories-list">
          {visibleInterviews.map(interview => <SuccessStoryCard key={interview.id} interview={interview} {...playback} />)}
        </div>
      </div>
    </div>
  );
}
